import axios from 'axios';

// Create a separate axios instance for public requests (no authentication)
const publicAxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    withCredentials: false, // Important: don't send cookies
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add response interceptor for error handling (but no auth redirects)
publicAxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Log errors but don't redirect to login
        console.error('Public API Error:', error);
        return Promise.reject(error);
    }
);

export default publicAxiosInstance;